import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { BREAKPOINT_MOBILE } from "constants/constants";
import { DASHBOARD_CARD_PROPS } from "../../dashboardPagesContentUtils";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import MachineBreakdownChart from "components/Dashboard/MachineBreakdownChart/MachineBreakdownChart";
import ShowTimelineButton from "components/FlightTrends/ShowTimelineButton";
import { useDisplayTimelinePageTimelines } from "../../useDisplayTimelinePageTimelines";
import { css } from "styled-components/macro";

export function MachineBreakdownChartCard() {
  const { translate } = useFlightTranslation();

  return (
    <CardWithControls
      title={translate("Process_Breakdown")}
      {...DASHBOARD_CARD_PROPS}
      collapsible={true}
      // padding-left to line up with TimelinesStyles & make room for CallIcon
      customCss={css`
        .cardContent {
          padding: 20px 16px;
          position: relative;
          @media (min-width: ${BREAKPOINT_MOBILE}px) {
            padding-left: 22px;
            padding-right: 22px;
          }
        }
      `}
    >
      <MachineBreakdownChartSection />
    </CardWithControls>
  );
}

function MachineBreakdownChartSection() {
  const [showTimelines, setShowTimelines] = useDisplayTimelinePageTimelines();
  return showTimelines ? (
    <MachineBreakdownChart />
  ) : (
    <ShowTimelineButton
      onClick={() => setShowTimelines(true)}
      showNote={false}
    />
  );
}
